/** Returns two letters for the avatar. */
export const getAvatarLetters = (name: string): string => {
  const words = (name || "").trim().split(/\s+/);
  if (words.length >= 2) {
    // If there's more two or more, keep two letters.
    return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
  } else if (words.length === 1) {
    // Otherwise one.
    return words[0].charAt(0).toUpperCase();
  }
  return "";
};
